export default __webpack_public_path__ + "static/media/IconDesc_PetroleumCoke.256.b6ae1a8f.png";